/**
 * Navigation Module
 * Mobile menu, navigation, dropdowns, and tab view
 */

import { isMobile, isTab } from "./utils.js";

export function initNavigation() {
  const mobileToggle = document.querySelector(".menu-toggle");
  const navigation = document.querySelector(".site-navigation");
  const mainMenu = navigation?.querySelector(".main-menu");
  const menuItemsWithChildren = navigation
    ? navigation.querySelectorAll(".menu-item-has-children")
    : [];

  initScrollHeader();
  initDropdownAnimations();
  initTabView();

  if (!navigation || !mainMenu) {
    return;
  }

  setupMobileSubmenuToggles(menuItemsWithChildren);

  // Mobile menu toggle
  if (mobileToggle) {
    mobileToggle.addEventListener("click", (e) => {
      e.preventDefault();
      toggleMobileMenu(mobileToggle, navigation);
    });
  }

  // Close mobile menu when clicking outside
  document.addEventListener("click", (e) => {
    if (
      (isMobile() || isTab()) &&
      navigation &&
      navigation.classList.contains("active") &&
      !e.target.closest(".site-navigation") &&
      !e.target.closest(".menu-toggle")
    ) {
      closeMobileMenu(mobileToggle, navigation, menuItemsWithChildren);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (
      e.key === "Escape" &&
      (isMobile() || isTab()) &&
      navigation.classList.contains("active")
    ) {
      closeMobileMenu(mobileToggle, navigation, menuItemsWithChildren);
    }
  });

  // Handle window resize
  window.addEventListener("resize", () => {
    if (!isMobile() && !isTab()) {
      resetMobileMenu(mobileToggle, navigation, menuItemsWithChildren);
    }
  });
}

function setupMobileSubmenuToggles(menuItemsWithChildren) {
  menuItemsWithChildren.forEach((item) => {
    const submenu = item.querySelector(":scope > .sub-menu");
    const link = item.querySelector(":scope > a");

    if (!submenu || !link) {
      return;
    }

    let toggleButton = item.querySelector(":scope > .submenu-toggle");

    if (!toggleButton) {
      toggleButton = document.createElement("button");
      toggleButton.type = "button";
      toggleButton.className = "submenu-toggle";
      toggleButton.setAttribute("aria-expanded", "false");
      toggleButton.setAttribute(
        "aria-label",
        `Toggle submenu for ${link.textContent.trim()}`
      );
      item.appendChild(toggleButton);
    }

    toggleButton.addEventListener("click", (e) => {
      if (!isMobile() && !isTab()) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      toggleSubmenu(item);
    });
  });
}

function toggleMobileMenu(toggle, navigation) {
  toggle.classList.toggle("active");
  navigation.classList.toggle("active");
  document.body.classList.toggle("no-scroll", navigation.classList.contains("active"));
}

function toggleSubmenu(item) {
  const isActive = item.classList.contains("active");

  // Close other submenus at the same level
  const siblings = item.parentElement.children;
  Array.from(siblings).forEach((sibling) => {
    if (
      sibling !== item &&
      sibling.classList.contains("menu-item-has-children")
    ) {
      sibling.classList.remove("active");
      updateSubmenuToggleState(sibling, false);
    }
  });

  item.classList.toggle("active", !isActive);
  updateSubmenuToggleState(item, !isActive);
}

function closeMobileMenu(toggle, navigation, menuItems) {
  if (toggle) toggle.classList.remove("active");
  if (navigation) navigation.classList.remove("active");
  document.body.classList.remove("no-scroll");

  menuItems.forEach((item) => {
    item.classList.remove("active");
    updateSubmenuToggleState(item, false);
  });
}

function resetMobileMenu(toggle, navigation, menuItems) {
  if (toggle) toggle.classList.remove("active");
  if (navigation) {
    navigation.classList.remove("active");
  }
  document.body.classList.remove("no-scroll");

  menuItems.forEach((item) => {
    item.classList.remove("active");
    updateSubmenuToggleState(item, false);
  });
}

function updateSubmenuToggleState(item, isExpanded) {
  const toggleButton = item.querySelector(":scope > .submenu-toggle");

  if (toggleButton) {
    toggleButton.setAttribute("aria-expanded", isExpanded ? "true" : "false");
  }
}

function initDropdownAnimations() {
  const menuItems = document.querySelectorAll(".menu-item-has-children");

  menuItems.forEach((item) => {
    const submenu = item.querySelector(".sub-menu");
    if (submenu && !isMobile()) {
      item.addEventListener("mouseenter", () => {
        // Dropdown animation can be added here
      });

      item.addEventListener("mouseleave", () => {
        // Dropdown animation can be added here
      });
    }
  });
}

function initTabView() {
  if (isTab()) {
    console.log("tab View");

    let existingMenuTab = document.querySelector(".headerBasic__menuTab");
    if (existingMenuTab) {
      existingMenuTab.remove();
    }

    const newMenuDiv = document.createElement("div");
    newMenuDiv.className = "headerBasic__menuTab";

    const headerBottom = document.querySelector(".headerBasic__bottom");

    if (headerBottom) {
      headerBottom.insertAdjacentElement("afterend", newMenuDiv);

      const menuSearchElements = document.querySelectorAll(".headerBasic__menu");
      menuSearchElements.forEach((element) => {
        newMenuDiv.appendChild(element);
      });
    } else {
      console.warn(".headerBasic__bottom tidak ditemukan");
    }
  }

  if (isMobile()) {
    console.log("Mobile View");

    let existingMenuTab = document.querySelector(".headerBasic__menuTab");
    if (existingMenuTab) {
      existingMenuTab.remove();
    }

    const newMenuDiv = document.createElement("div");
    newMenuDiv.className = "headerBasic__menuTab";

    const headerBottom = document.querySelector(".headerBasic__bottom");
    const mobileToggle = document.querySelector(".headerBasic__mobile");

    if (mobileToggle) {
      mobileToggle.addEventListener("click", (e) => {
        e.preventDefault();
        newMenuDiv.classList.toggle("show");
        document.body.classList.toggle("no-scroll");
        window.scrollTo(0, 0);
      });
    }

    if (headerBottom) {
      headerBottom.insertAdjacentElement("afterend", newMenuDiv);

      const menuSearchElements = document.querySelectorAll(".headerBasic__menu");
      menuSearchElements.forEach((element) => {
        newMenuDiv.appendChild(element);
      });

      const cardLangElement = document.querySelector(".cardLang");
      if (cardLangElement && menuSearchElements.length > 0) {
        const lastMenu = menuSearchElements[menuSearchElements.length - 1];
        lastMenu.appendChild(cardLangElement);
      }

      const infoDiv = document.createElement("div");
      infoDiv.className = "headerBasic__info";
      newMenuDiv.appendChild(infoDiv);

      const infosElement = document.querySelector(".headerBasic__infos");
      if (infosElement) {
        infoDiv.appendChild(infosElement);
      }

      const sosmedElement = document.querySelector(".headerBasic__sosmed");
      if (sosmedElement) {
        infoDiv.appendChild(sosmedElement);
      }
    } else {
      console.warn(".headerBasic__bottom tidak ditemukan");
    }
  }
}

function initScrollHeader() {
  const siteHeader = document.querySelector(".site-header");
  if (!siteHeader) return;

  let lastScrollY = window.scrollY;
  let ticking = false;

  function updateHeader() {
    const currentScrollY = window.scrollY;

    // Add .scrolled if scrolled more than 0
    if (currentScrollY > 0) {
      siteHeader.classList.add("scrolled");
    } else {
      siteHeader.classList.remove("scrolled");
    }

    // Check scroll direction
    if (currentScrollY > lastScrollY && currentScrollY > 100) {
      // Scroll down (and past threshold)
      siteHeader.classList.add("scroll-down");
    } else {
      // Scroll up
      siteHeader.classList.remove("scroll-down");
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  });
}
